import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { InformationBar } from './information-bar.model';


@Injectable({ providedIn: 'root' })
export class InformationBarService {
    private subject = new Subject<InformationBar>();
    private defaultId = 'default-information-bar';

    // convenience methods
    createInformationBar(options?: any) {
        const informationBar = new InformationBar({ ...options});
        this.informationBar(informationBar);
    }

    // clear informationBars
    clearBlock(idBloc = this.defaultId) {
        this.subject.next(new InformationBar({ idBloc }));
    }

    clearInformationBar(idInformationBar: string) {
        this.informationBar(new InformationBar({idInformationBar: idInformationBar, remove: true}));
    }

    onInformationBar(idBloc = this.defaultId): Observable<InformationBar> {
        return this.subject.asObservable().pipe(filter(x => x && x.idBloc === idBloc));
    }

      // main informationBar method    
    private informationBar(informationBar: InformationBar) {
        informationBar.idBloc = informationBar.idBloc || this.defaultId;
        this.subject.next(informationBar);
    }
}